import {
	API_GET_ALL_CONSENT_REFUSAL_REASON,
	API_ADMIN_GET_ALL_CONSENT_REFUSAL_REASON,
	API_ADMIN_GET_CONSENT_REFUSAL_REASON,
	ADMIN_INIT_NEW_CONSENT_REFUSAL_REASON,
	ADMIN_RESET_FOCUS_CONSENT_REFUSAL_REASON,
	API_ADMIN_POST_CONSENT_REFUSAL_REASON,
	API_ADMIN_PATCH_CONSENT_REFUSAL_REASON,
	API_ADMIN_DELETE_CONSENT_REFUSAL_REASON,
} from 'actions/consentRefusalReason';

export function getAllConsentRefusalReasons() {
	return {
		type: API_GET_ALL_CONSENT_REFUSAL_REASON,
		payload: {
			request: {
				url: `/consentRefusalReasons`
			}
		}
	};
}

export function adminGetAllConsentRefusalReasons() {
	return {
		type: API_ADMIN_GET_ALL_CONSENT_REFUSAL_REASON,
		payload: {
			request: {
				url: `/admin/consentRefusalReasons`
			}
		}
	};
}

export function adminGetConsentRefusalReason(consentRefusalReason) {
	return {
		type: API_ADMIN_GET_CONSENT_REFUSAL_REASON,
		payload: {
			request: {
				url: `/admin/consentRefusalReasons/${consentRefusalReason.id}`
			}
		}
	};
}

export function adminPostConsentRefusalReason(consentRefusalReason) {
	return {
		type: API_ADMIN_POST_CONSENT_REFUSAL_REASON,
		payload: {
			request: {
				url: `/admin/consentRefusalReasons`,
				method: 'POST',
				data: consentRefusalReason
			}
		}
	};
}

export function adminPatchConsentRefusalReason(consentRefusalReason) {
	return {
		type: API_ADMIN_PATCH_CONSENT_REFUSAL_REASON,
		payload: {
			request: {
				url: `/admin/consentRefusalReasons/${consentRefusalReason.id}`,
				method: 'PATCH',
				data: consentRefusalReason
			}
		}
	};
}

export function adminDeleteConsentRefusalReason(consentRefusalReason) {
	return {
		type: API_ADMIN_DELETE_CONSENT_REFUSAL_REASON,
		payload: {
			request: {
				url: `/admin/consentRefusalReasons/${consentRefusalReason.id}`,
				method: 'DELETE'
			}
		}
	};
}

export function initNewConsentRefusalReason() {
	return {
		type: ADMIN_INIT_NEW_CONSENT_REFUSAL_REASON
	};
}

export function resetFocusConsentRefusalReason() {
	return {
		type: ADMIN_RESET_FOCUS_CONSENT_REFUSAL_REASON
	};
}
